import { AnalyticsModule } from './analytics/analytics.module';
import { ApiModule } from './api/api.module';
import { ApplicationConfigModule } from './application-config/application-config.module';
import { ClientConfigurationModule } from './client-configuration/client-configuration.module';
import { CommonModule } from '@angular/common';
import { EnvironmentModule } from './environment/environment.module';
import { InitializeModule } from './initialize/initialize.module';
import { LocaleModule } from './locale/locale.module';
import { MerchantDetailsModule } from './merchant-details/merchant-details.module';
import { NgModule } from '@angular/core';
import { NotificationModule } from './notification/notification.module';
import { PageSpinnerModule } from './page-spinner/page-spinner.module';
import { RoutingModule } from './routing/routing.module';
import { SessionModule } from './session/session.module';
import { SpinnerModule } from '../feature/spinner/spinner.module';
import { UserModule } from './user/user.module';
import { ToastModule } from './toast/toast.module';

@NgModule({
	declarations: [],
	imports: [
		AnalyticsModule,
		ApiModule,
		ApplicationConfigModule,
		ClientConfigurationModule,
		CommonModule,
		EnvironmentModule,
		InitializeModule,
		LocaleModule,
		MerchantDetailsModule,
		PageSpinnerModule,
		NotificationModule,
		ToastModule,
		RoutingModule,
		SessionModule,
		UserModule,
		SpinnerModule,
	],
})
export class CoreModule {}
